export default __webpack_public_path__ + "static/default-00f1da0c90aceca318bff1f7d67f9607.png";